export default function keyMirror(obj) {
  const result = {};
  Object.keys(obj).forEach((key) => {
    result[key] = key;
  });
  return result;
}
